// Add this at the beginning of your app entry.
import 'vite/modulepreload-polyfill';
import '/js/alpine';
// used to render 2fa qrcode
import QRCode from 'qrcode/lib/browser';
window.QRCode = QRCode;

console.log('Starting vite js!');
